// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

import type { ObjectRelationshipDirection } from "./types";

const maybeNullString = anyOf(nullOrUndefined, string);

const isObjectRelationshipDirection = (val: unknown): val is ObjectRelationshipDirection =>
  val === "outgoing" || val === "incoming";

const isCustomObjectsTypeNameExternalIdObjectRelationshipsResultItem = objectOf({
  id: string,
  external_id: string,
  display_name: maybeNullString,
  type_name: maybeNullString,
  rel_kind: maybeNullString,
  relationship_name: maybeNullString,
  direction: isObjectRelationshipDirection,
});

export const isCustomObjectsTypeNameExternalIdObjectRelationshipsResult = objectOf({
  hits: number,
  results: arrayOf(isCustomObjectsTypeNameExternalIdObjectRelationshipsResultItem),
});
